import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    input,
    output,
    signal,
    WritableSignal,
} from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

const FIRST_PAGE = 1;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-paginator',
    styleUrl: './paginator.component.scss',
    templateUrl: './paginator.component.html',
})
export class PaginatorComponent {
    public readonly currentPage: WritableSignal<number> = signal(FIRST_PAGE);
    public onPageChange = output<number>();
    public readonly page = input<number | null>(null);
    public readonly take = input.required<number>();
    public readonly totalItems = input.required<number>();
    public readonly totalPages = computed(() => {
        const takeValue = this.take();

        return Math.ceil((this.totalItems() ?? 0) / takeValue);
    });

    public constructor() {
        effect(() => {
            const page = this.page();

            if (page === null) {
                return;
            }

            const requestedPage = page + 1;

            if (requestedPage !== this.currentPage()) {
                this.currentPage.set(requestedPage);
            }
        });
    }

    public nextPage(): void {
        if (this.currentPage() < this.totalPages()) {
            this.setCurrentPage(this.currentPage() + 1);
        }
    }

    public previousPage(): void {
        if (this.currentPage() > 1) {
            this.setCurrentPage(this.currentPage() - 1);
        }
    }

    public resetPaginator(): void {
        this.setCurrentPage(FIRST_PAGE);
    }

    public setCurrentPage(page: number): void {
        if (page === this.currentPage() || page > this.totalPages()) {
            return;
        }

        this.currentPage.set(page);
        this.onPageChange.emit(this.currentPage() - 1);
    }
}
